import { bool, object } from 'yup';

export const EbpCaseDischargeOptionsSchema = object().shape({
  emails: object().shape({
    skipEmailToClientDischarged: bool(),
    skipEmailToClientFeedback: bool(),
  }),
});
